export class ProviderDetails {
    accountId?: string;

    name?: string;

    sapId?: string;

    siteId: string;
}
